var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarFeatures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.23512 21.7651C2.43823 21.9682 2.64993 22.1534 2.86406 22.3243C4.49013 23.6225 6.79512 23.2733 8.22065 22.0017C9.21477 21.1147 10.2438 20.1833 11.2479 19.1793C12.1384 18.2887 12.9718 17.3786 13.7677 16.4904C14.9643 16.9736 16.1773 17.1257 17.3649 16.9062C18.6941 16.6605 19.9212 15.9623 21.011 14.8726C22.1349 13.7487 22.8418 12.4789 23.0661 11.103C23.2905 9.72622 23.0187 8.32025 22.3169 6.94733C21.9969 6.32124 21.1774 6.22635 20.7082 6.69562C20.2716 7.13223 19.8389 7.59188 19.4357 8.02027C19.1823 8.28944 18.9403 8.54648 18.7166 8.7775C18.1041 9.40963 17.5762 9.90314 17.0816 10.2259C16.5959 10.5429 16.2148 10.6475 15.8747 10.6126C15.5322 10.5774 14.946 10.2552 14.3455 9.65472C13.745 9.0542 13.4226 8.46795 13.3874 8.12549C13.3525 7.78539 13.4571 7.40424 13.7741 6.91853C14.0969 6.42396 14.5904 5.89603 15.2225 5.28362C15.4535 5.0598 15.7106 4.81784 15.9797 4.56446C16.408 4.16129 16.8679 3.72845 17.3043 3.29194C17.7737 2.82266 17.6787 2.0033 17.0527 1.68325C15.6798 0.981449 14.2738 0.709733 12.897 0.934092C11.5211 1.15829 10.2513 1.8653 9.12746 2.98915C8.03774 4.07887 7.33954 5.30611 7.09383 6.63538C6.87434 7.82285 7.02639 9.03581 7.5096 10.2325C6.62151 11.0284 5.71128 11.8617 4.82073 12.7523C3.8167 13.7563 2.88533 14.7854 1.99843 15.7795C0.726633 17.2051 0.37751 19.5099 1.67569 21.1361C1.84665 21.3502 2.03199 21.5619 2.23512 21.7651Z",
    stroke: "black",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarFeatures);
export default __webpack_public_path__ + "static/media/sidebar_features.a0496c363493d01db1606f9a6c6ee117.svg";
export { ForwardRef as ReactComponent };